import { cryptoReportRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const cryptoReportRoute: RouteObject[] = [
  {
    path: cryptoReportRoutePaths.list.path,
    async lazy() {
      const CryptoReportList = await import('@/pages/crypto-report/CryptoReportList');
      return { Component: CryptoReportList.default };
    },
  },
  {
    path: cryptoReportRoutePaths.detail.path,
    async lazy() {
      const CryptoReportDetail = await import('@/pages/crypto-report/CryptoReportDetail');
      return { Component: CryptoReportDetail.default };
    },
  },
];
